export const formatHoursToHm = (value) => {
  let hours = Math.floor(value);
  let decimalPart = value - hours;
  let minutes = Math.round(decimalPart * 60);

  // Handle edge case where minutes reach 60
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  let result = "";
  if (hours > 0) {
    result += `${hours}h`;
  }
  if (minutes > 0) {
    if (result.length > 0) result += " ";
    result += `${minutes}m`;
  }
  if (result === "") {
    result = "0h"; // Handle zero value
  }
  return result;
};

export const addISTOffset = (utcDate) => {
  // If empty, null, undefined → return null
  if (!utcDate || utcDate === "null" || utcDate === "undefined") {
    return null;
  }

  const date = new Date(utcDate);

  // If invalid date → return null
  if (isNaN(date.getTime())) {
    return null;
  }

  // Add 5 hours and 30 minutes
  date.setHours(date.getHours() + 5);
  date.setMinutes(date.getMinutes() + 30);
  return date.toISOString();
};
